import webcall from '@/scripts/webcall';
import sourceGenerator, { VideoSourceResponse, GeneratedVideoSourcePayload } from './sourceGenerator';
import playerErrorResolver from './playerErrorResolver';
import PLAYER_ERRORS from './PLAYER_ERRORS';
import { Model } from '@viddsee/server-api-client';

const JWPLAYER_ERROR = {
  HLS_ERROR: 'Cannot load M3U8: Crossdomain access denied',
  LOADING_ERROR: 'Error loading media: File could not be played',
  PLAY_ERROR: 'This video file cannot be played.',
};

interface VideoSourceGetterOptions {
  uid: string;
  token: string;
  source: 'web';
}

const sourceGetter = {
  obtainVideoSource(
    { uid, token, source }: VideoSourceGetterOptions,
    forceHosted = false,
  ): Promise<VideoSourceResponse> {
    const webcallCredential = ({
      // eslint-disable-next-line @typescript-eslint/camelcase
      video_id: uid,
      // eslint-disable-next-line @typescript-eslint/camelcase
      page_token: token,
      source: source || 'web',
    });

    const getSourceFn = forceHosted
      ? webcall.video.getHostedSources
      : webcall.video.getSources
    ;
    return getSourceFn(webcallCredential);
  },

  generateAVideoPlaylistItem(video: Model.Video.Info) {
    return (videoResponse: VideoSourceResponse): GeneratedVideoSourcePayload => sourceGenerator.generate(videoResponse, video);
  },

  obtainFallbackVideoSource(message: string, existingVideoSource?: GeneratedVideoSourcePayload | null): Promise<VideoSourceResponse | void> {
    return new Promise((resolve, reject) => {
      if (!existingVideoSource || !existingVideoSource.sources) {
        return reject(new Error(PLAYER_ERRORS.NO_SOURCE));
      }

      switch (message) {
        case JWPLAYER_ERROR.HLS_ERROR: {
          resolve(playerErrorResolver.resolveHlsStreamingError(existingVideoSource));
          return;
        }
        case JWPLAYER_ERROR.PLAY_ERROR:
        case JWPLAYER_ERROR.LOADING_ERROR: {
          resolve(playerErrorResolver.resolveMediaLoadingError(existingVideoSource));
          return;
        }
        default: {
          reject(new Error(PLAYER_ERRORS.UNABLE_TO_RECOVER));
        }
      }
    });
  },
};

export default sourceGetter;
